<template>
  <div style="background: #eeeeee;" class="addColaboradores pa-1">
    <v-card>
      <h3 class="white--text text--lighten-4 blue-grey darken-3">
        <v-card-title class="title">
          <v-icon large color="orange lighten-4" class>mdi-account-details</v-icon>R.H > Lista de Colaboradores
        </v-card-title>
      </h3>

      <v-spacer></v-spacer>
      <v-row class="pl-5 pb-5">
        <v-col>
          <h4 class="orange--text title px-auto">Segue a lista dos Colaboradores cadastrados</h4>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="6">
          <v-text-field v-model="dataSearch" prepend-icon="mdi-comment-search-outline" :clearable="true" dense
            label="Procurar Colaborador" single-line hide-details>></v-text-field>
        </v-col>
        <v-col cols="6">
          <v-btn align="middle" small color="orange lighten-4" class="mb-2 mx-12" to="addColaboradores">Adicionar
            Colaborador</v-btn>
        </v-col>
      </v-row>
      <v-data-table class="caption" :headers="headersDataCol" :items="dataCol" :search="dataSearch">
        <template v-slot:[`item.ativo`]="{ item }">
          <v-icon class="ml-n2" :color="corAtivo(item.ativo)">{{ iconeAtivo(item.ativo) }}</v-icon>
        </template>
        <template v-slot:[`item.email`]="{ item }">{{ item.email }}</template>
        <template v-slot:[`item.acoes`]="{ item }">
          <v-icon class="mr-2" small color="blue" @click="editColaborador(item)">mdi-pencil</v-icon>
          <v-icon small @click="removerColaborador(item, true)" color="red">mdi-delete</v-icon>
        </template>
        <template v-slot:[`item.setores`]="{ item }">
          <template v-for="setor in item.setores">
            <span v-if="setor !== 'Assuntos Gerais'" :key="setor" v-html="setor + '<br>'"></span>
          </template>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="editDialog" scrollable min-width="50%" max-width="800px">
      <v-card height="600px">
        <v-alert type="info" class="text-center" dense>
          <strong>MODIFICANDO COLABORADOR</strong>
        </v-alert>
        <p class="body-2 text-center ma-4">
          Modificando os dados de
          <strong>{{ col.nome }}</strong>
        </p>
        <v-divider></v-divider>
        <vuescroll ref="vs" :ops="ops">
          <v-form class="mt-5 mx-3" v-model="valid" @submit.prevent>
            <h4>O Colaborador ainda está ativo em nosso sistema?</h4>
            <v-checkbox v-model="ativo" dense label="Ativo" color="orange darken-3"></v-checkbox>

            <v-text-field outlined label="Nome Completo" hint="Exemplo: Victor Barbieri" prepend-icon="mdi-smart-card"
              required clearable dense :rules="nomeRules" v-model="nome"></v-text-field>
            <h4>Gênero:</h4>
            <v-radio-group row required dense v-model="genero">
              <v-card class="mr-4">
                <v-card-title>
                  <v-icon>mdi-human-male</v-icon>
                  <v-radio label="Masculino" color="orange darken-3" value="Masculino"></v-radio>
                </v-card-title>
              </v-card>
              <v-card>
                <v-card-title>
                  <v-icon>mdi-human-female</v-icon>
                  <v-radio label="Feminino" color="orange darken-3" value="Feminino"></v-radio>
                </v-card-title>
              </v-card>
            </v-radio-group>
            <!--<v-file-input
              accept="image/*"
              small-chips
              outlined
              dense
              v-model="foto"
              label="Foto do Perfil"
              prepend-icon="mdi-camera"
            ></v-file-input> !-->
            <v-text-field outlined label="P.I.S" value prepend-icon="mdi-wallet-plus" dense v-model="pis"
              :rules="pisRules" counter required></v-text-field>
            <v-menu v-model="calendarioEntradaMenu" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field outlined value prepend-icon="mdi-calendar" label="Data de entrada do Colaborador" dense
                  v-model="dataEntrada" clearable required readonly v-on="on"></v-text-field>
              </template>
              <v-date-picker color="orange darken-3" v-model="dataSEntrada" locale="pt-br"
                @input="calendarioEntradaMenu = false"></v-date-picker>
            </v-menu>
            <v-menu v-model="calendarioSaidaMenu" :close-on-content-click="false" :nudge-right="40"
              transition="scale-transition" max-width="290px" offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field outlined prepend-icon="mdi-exit-run" label="Data de saida do Colaborador" dense
                  v-model="dataSaida" readonly clearable @blur="dataSSaida = parseDate(dataSaida)"
                  v-on="on"></v-text-field>
              </template>
              <v-date-picker color="orange darken-3" v-model="dataSSaida" locale="pt-br"
                @input="calendarioSaidaMenu = false"></v-date-picker>
            </v-menu>
            <h4>Jornada Semanal de Trabalho:</h4>
            <v-radio-group row required dense v-model="jornadaSemanal">
              <v-card class="mr-3">
                <v-card-title>
                  <v-icon>mdi-timer-sand-empty</v-icon>
                  <v-radio label="36 Horas / Semana" color="orange darken-3" value="36:00:00"></v-radio>
                </v-card-title>
              </v-card>
              <v-card>
                <v-card-title>
                  <v-icon>mdi-timer-sand-empty</v-icon>
                  <v-radio label="44 Horas / Semana" color="orange darken-3" value="44:00:00"></v-radio>
                </v-card-title>
              </v-card>
            </v-radio-group>
            <h4>Setores em que trabalha:</h4>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-home-currency-usd</v-icon>
                    <v-switch v-model="setores" dense label="Cobrança" color="orange darken-3"
                      value="Cobrança"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-briefcase-account</v-icon>
                    <v-switch v-model="setores" dense label="Contábil" color="orange darken-3"
                      value="Contábil"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-bank-transfer-in</v-icon>
                    <v-switch dense v-model="setores" label="Escrita Fiscal" color="orange darken-3"
                      value="Escrita Fiscal"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-tie</v-icon>
                    <v-switch v-model="setores" dense label="I.R" color="orange darken-3"
                      value="Imposto de Renda"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-tie</v-icon>
                    <v-switch v-model="setores" dense label="Paralegal" color="orange darken-3"
                      value="Paralegal"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-table-account</v-icon>
                    <v-switch v-model="setores" dense label="R.H" color="orange darken-3"
                      value="Recursos Humanos"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-language-javascript</v-icon>
                    <v-switch v-model="setores" dense label="T.I" color="orange darken-3" value="T.I"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col>
                <v-card>
                  <v-card-title>
                    <v-icon class="mr-1" large>mdi-account-tie</v-icon>

                    <v-switch v-model="setores" dense label="Gerência" color="orange darken-3"
                      value="Gerência"></v-switch>
                  </v-card-title>
                </v-card>
              </v-col>
              <v-col></v-col>
            </v-row>
            <v-text-field outlined autocomplete="username" label="E-mail" prepend-icon="mdi-card-account-mail"
              :persistent-hint="true" hint="nome.s" :rules="emailRules" v-model="email" suffix="@contabilidadelider.com"
              dense required></v-text-field>
            <v-text-field outlined label="Senha" prepend-icon="mdi-lock" :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show1 ? 'text' : 'password'" counter="15" dense :rules="passRules" v-model="senha"
              @click:append="show1 = !show1"></v-text-field>
          </v-form>
        </vuescroll>
        <v-divider></v-divider>
        <p class="text-center">
          <v-btn color="green darken-1" text :disabled="!valid" :loading="loading" @click="(loader = 'loading');
          editDialog = false
          editarColBD();
          ">MODIFICAR</v-btn>
          <v-btn color="red darken-1" text @click="editDialog = false">CANCELAR EDIÇÃO</v-btn>
        </p>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogResposta" min-width="20%" max-width="450px">
      <v-card>
        <v-col v-if="message == 'error'">
          <v-alert type="error" class="text-center" dense>
            Tivemos um problema.
            <strong>Colaborador NÃO</strong> modificado/removido
          </v-alert>
          <p class="caption text-center">
            Por favor contate o setor de T.I.
            <br />
            <strong>E-mail:</strong> ti@contabilidadelider.com
          </p>
          <code v-text="respostaErro"></code>
        </v-col>
        <v-col v-else-if="message == 'success'">
          <v-alert type="success" class="text-center" dense>
            <strong>Coloborador</strong> modificado/removido com sucesso.
          </v-alert>
        </v-col>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogRemoverColaborador" max-width="400">
      <v-card>
        <v-alert type="info" class="text-center" dense>
          <strong>REMOVER COLABORADOR</strong>
        </v-alert>
        <p class="body-2 text-center">
          Você gostaria de
          <strong>REMOVER</strong> o colaborador:
          <br />
          <br />
          <strong>{{ col.nome }}</strong>
          ?
          <br />
          <br />
          <strong>Está ação não poderá ser desfeita.</strong>
          <v-btn color="green darken-1" text @click="
            removerColaborador(null, false);
          dialogRemoverColaborador = false;
          ">REMOVER COLABORADOR</v-btn>
          <v-btn color="red darken-1" text @click="dialogRemoverColaborador = false">NÃO REMOVER</v-btn>
        </p>
        <br />
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import vuescroll from "vuescroll/dist/vuescroll-native";
export default {
  name: "listColaboradores",
  components: { vuescroll },
  data() {
    return {
      //formulario
      show1: false,
      loading: false,
      loader: null,
      valid: true,
      nome: "",
      ativo: false,
      senha: "",
      senhaB: "",
      foto: null,
      pis: "",
      jornadaSemanal: "44:00:00",
      genero: "Feminino",
      email: "",
      dialogRemoverColaborador: false,
      message: "",
      respostaErro: "",
      dataSEntrada: new Date().toISOString().substr(0, 10),
      dataSSaida: null,
      calendarioEntradaMenu: false,
      calendarioSaidaMenu: false,
      dialogResposta: false,
      setores: "",
      nomeRules: [
        (value) => !!value || "Informe o nome Completo",
        (value) =>
          value.length <= 40 || "Seu Nome deve ter no máximo 40 caracteres",
        (value) =>
          /^[a-zA-Z\u00c0-\u024f\u1e00-\u1eff\s]+$/.test(value) ||
          "O nome só pode conter letras",
      ],
      pisRules: [
        (value) => !!value || "Informe o P.I.S do colaborador",
        (value) =>
          value.length <= 11 || "O P.I.S deve conter no máximo 11 numeros",
        (value) => /^\d+$/.test(value) || "O P.I.S deve conter somente numeros",
        (value) =>
          value.length >= 11 || "O P.I.S deve conter no mínimo 11 numeros",
      ],
      emailRules: [
        (value) => !!value || "Informe o e-mail",
        (value) =>
          value.length <= 15 || "Seu usuário deve ter no máximo 15 caracteres",
        (value) =>
          /^[a-z0-9.]+$/.test(value) ||
          "O seu usuário deve conter somente letras, numeros, - (hifem) e . (ponto).",
      ],
      passRules: [
        (value) =>
          value.length <= 15 || "Sua senha deve ter no máximo 15 caracteres",
      ],

      //end
      dataSearch: "",
      editDialog: false,
      removeDialog: false,
      col: "",
      dataCol: [],
      headersDataCol: [
        {
          text: "Ativo?",
          value: "ativo",
          align: "center",
        },
        { text: "Nome", value: "nome" },
        { text: "E-mail", value: "email" },
        { text: "Genero", value: "genero" },
        { text: "P.I.S", value: "pis" },
        { text: "Data de Entrada", value: "dataEntrada" },
        { text: "Data de Saida", value: "dataSaida" },
        { text: "Jornada", value: "jornadaSemanal" },
        { text: "Setores", value: "setores" },
        { text: "Ações", value: "acoes", sortable: false, align: "end" },
      ],
      ops: {
        vuescroll: {
          detectResize: false,
        },
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: true,
          keepShow: true,
          background: "#37474F",
          opacity: 0.5,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: 0,
          size: "6px",
          disable: false,
        },
      },
    };
  },
  computed: {
    dataEntrada() {
      return this.formatDate(this.dataSEntrada);
    },
    dataSaida() {
      return this.formatDate(this.dataSSaida);
    },
  },
  watch: {
    setores(newVal, oldVal) {
      if (newVal.length) {
        this.setores = newVal;
      } else {
        setTimeout(() => (this.setores = oldVal));
      }
    },
  },
  methods: {
    parseDate(date) {
      if (!date) return null;
    },
    formatDate(date, rev = false) {
      if (!rev) {
        if (!date) return null;
        const [year, month, day] = date.split("-");
        return `${day}/${month}/${year}`;
      } else {
        var [deYear, deMonth, deDay] = date.split("/");
        return `${deDay}-${deMonth}-${deYear}`;
      }
    },
    editColaborador(col) {
      this.editDialog = true;
      setTimeout(() => {
        this.scrollToElement();
      }, 10);
      this.col = col;
      this.nome = col.nome;
      this.genero = col.genero;
      this.pis = col.pis;
      this.dataSEntrada = this.formatDate(col.dataEntrada, true);
      if (col.dataSaida !== null) {
        this.dataSSaida =
          col.dataSaida === "" || typeof col.dataSaida === "undefined"
            ? null
            : this.formatDate(col.dataSaida, true);
      }
      col.jornadaSemanal === "44:00:00"
        ? (this.jornadaSemanal = "44:00:00")
        : (this.jornadaSemanal = "36:00:00");
      this.ativo = col.ativo;
      this.setores = col.setores;
      this.email = col.email;
      this.senhaB = col.senha;
      // .then
      // () => {
      //   this.dialogResposta = true;
      //   this.message = "success";
      // },
      // error => {
      //   this.dialogResposta = true;
      //   this.loading = false;
      //   this.respostaErro = error;
      //   this.message = "error";
      // }
      // ();
    },

    removerColaborador(col, dialog) {
      if (dialog) {
        this.col = col;
        this.dialogRemoverColaborador = true;
      } else {
        this.payload = {
          id: this.col._id,
        };
        this.$;
        this.$store.dispatch("removerUsuario", this.payload).then(
          (result) => {
            this.dataCol = result;
            this.dialogResposta = true;
            this.message = "success";
          },
          (error) => {
            this.dialogResposta = true;
            this.loading = false;
            this.respostaErro = error;
            this.message = "error";
          }
        );
      }
    },
    editarColBD() {
      this.senhaB = this.senha !== "" ? this.senha : this.senhaB;
      this.payload = {
        id: this.col._id,
        nome: this.nome,
        genero: this.genero,
        foto: this.foto,
        pis: this.pis,
        dataEntrada: this.dataEntrada,
        dataSaida: this.dataSaida,
        jornadaSemanal: this.jornadaSemanal,
        setores: this.setores,
        ativo: this.ativo,
        email: this.email,
        senha: this.senhaB,
      };
      this.$store.dispatch("editUsuario", this.payload).then(
        (result) => {
          this.dataCol = result;
          this.dialogResposta = true;
          this.message = "success";
        },
        (error) => {
          this.dialogResposta = true;
          this.loading = false;
          this.respostaErro = error;
          this.message = "error";
        }
      );
    },
    iconeAtivo(ativo) {
      return ativo
        ? "mdi-checkbox-marked-circle-outline"
        : "mdi-close-circle-outline";
    },
    corAtivo(ativo) {
      return ativo ? "green" : "red";
    },
    scrollToElement() {
      if (typeof this.$refs["vs"] !== "undefined") {
        this.$refs["vs"].scrollBy(
          {
            dy: -4000,
          },
          0
        );
      }
    },
  },
  mounted() {
    this.$store.dispatch("listarUsuario").then(
      (usuarios) => {
        this.dataCol = usuarios;
      },
      () => {
        this.$router.push("/");
      }
    );
  },
};
</script>